export default {
  version : 0.1,
  siteName : '华创系统管理平台',
  accessTokenKey : 'HC-SMP-Authorization',
  refreshTokenKey : 'HC-SMP-RefreshToken',
  appCode : 'hc-platform-manager',
  scope : 'webclient',
  grantType : 'password',

  tabCompShowMode:1,  //1动态组件  2路由模式
  
  MENU_CODE_LEVEL_LENGTH : 4,
  DEPT_CODE_LEVEL_LENGTH : 4, 
}
